import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

export function getGreeting(hour = new Date().getHours()): string {
	if (hour < 12) return 'Buenos días';
	if (hour < 19) return 'Buenas tardes';
	return 'Buenas noches';
}

export function formatFullDate(date = new Date()): string {
	// eslint-disable-next-line quotes
	const formatted = format(date, "EEEE, d 'de' MMMM 'de' yyyy", {
		locale: es,
	});
	return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function formatChartDate(dateStr: string): string {
	return format(parseISO(dateStr), 'dd MMM', { locale: es });
}

export function formatRelativeTime(timestamp: string): string {
	const date = new Date(timestamp);
	const now = new Date();
	const diffMs = now.getTime() - date.getTime();
	const diffMinutes = Math.floor(diffMs / 60000);
	const diffHours = Math.floor(diffMs / 3600000);
	const diffDays = Math.floor(diffMs / 86400000);

	if (diffMinutes < 1) return 'Ahora';
	if (diffMinutes < 60) return `Hace ${diffMinutes} min`;
	if (diffHours < 24) return `Hace ${diffHours} h`;

	const yesterday = new Date(now);
	yesterday.setDate(yesterday.getDate() - 1);
	if (
		date.getDate() === yesterday.getDate() &&
		date.getMonth() === yesterday.getMonth() &&
		date.getFullYear() === yesterday.getFullYear()
	) {
		return 'Ayer';
	}

	if (diffDays < 7) return `Hace ${diffDays} días`;

	return format(date, 'd MMM', { locale: es });
}

export const SPARKLINE_COLORS: Record<string, string> = {
	orange: '#FF5C00',
	blue: '#2563EB',
	green: '#1a9a50',
	amber: '#D97706',
	purple: '#7C3AED',
	red: '#DC2626',
	gray: '#C7CCD1',
};

export const ACTIVITY_DOT_COLORS: Record<string, string> = {
	install: '#1a9a50',
	geo: '#FF5C00',
	alert: '#DC2626',
};
